// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
const headerData = {
  about: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_about"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_about"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_about"),
  },
  account: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_account"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_account"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_account"),
  },
  business: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_business"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_business"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_business"),
  },
  company: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_company"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_company"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_company"),
  },
  cookies: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_cookies"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_cookies"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_cookies"),
  },
  cookies_settings: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_cookies_settings"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_cookies_settings"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_cookies_settings"),
  },
  mobile: {
    // @ts-expect-error: Flow to TS migration.
    title: __("content.mobile.title_v2"),
    // @ts-expect-error: Flow to TS migration.
    description: __("content.mobile.subtitle_v2"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_mobile"),
  },
  faq: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_faq"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_faq"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_faq"),
  },
  feedback: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_feedback"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_feedback"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_feedback"),
  },
  guarantee: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_guarantee"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_guarantee"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_guarantee"),
  },
  legal: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_legal"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_legal"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_legal"),
  },
  "legal-refer-friend": {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_legal_refer_friend"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_legal_refer_friend"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_legal_refer_friend"),
  },
  media: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_media"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_media"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_media"),
  },
  partner: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_partner"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_partner"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_partner"),
  },
  people: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_people"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_people"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_people"),
  },
  privacy: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_privacy"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_privacy"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_privacy"),
  },
  "privacy-research": {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_privacy_research"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_privacy_research"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_privacy_research"),
  },
  product: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_product"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_product"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_product"),
  },
  refund: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_refund"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_refund"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_refund"),
  },
  team: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_team"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_team"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_team"),
  },
  security: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_security"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_security"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_security"),
  },
  widgets: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_widgets"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_widgets"),
    // @ts-expect-error: Flow to TS migration.
    keywords: __("seo.content.keywords_widgets"),
  },
  compass: {
    // @ts-expect-error: Flow to TS migration.
    title: __("seo.content.title_compass"),
    // @ts-expect-error: Flow to TS migration.
    description: __("seo.content.description_compass"),
    image_og: "/images/compass/compass-ogimage.png",
    image_twitter: "/images/compass/compass-ogimage.png",
  },
} as const

export type HeaderData = {
  title: string
  description: string
  keywords?: string
  image_og?: string
  image_twitter?: string
}

export type Page = keyof typeof headerData

export default headerData
